export default __webpack_public_path__ + "static/media/git.0e2dcfcc.png";